import { useEffect, useRef, useState } from "react";
import { useApi } from "@/lib/api";

// Server-side search + «load more» over /tenants/page (thousands of client spaces); stale responses are dropped.
export function useTenantPage({ q, includeArchived = false, limit = 50 }) {
  const api = useApi();
  const [st, setSt] = useState({ items: [], total: 0, has_more: false, loading: true, error: null });
  const seq = useRef(0);
  const fetchPage = (offset, append) => {
    const n = ++seq.current;
    setSt((s) => ({ ...s, loading: true, error: null }));
    api.get("/tenants/page", { params: { q, offset, limit, include_archived: includeArchived } })
      .then(({ data }) => { if (n === seq.current) setSt((s) => ({ items: append ? [...s.items, ...data.items] : data.items, total: data.total, has_more: data.has_more, loading: false, error: null })); })
      .catch((e) => { if (n === seq.current) setSt((s) => ({ ...s, loading: false, error: e })); });
  };
  useEffect(() => {
    const h = setTimeout(() => fetchPage(0, false), q ? 250 : 0);
    return () => clearTimeout(h);
  }, [api, q, includeArchived, limit]); // eslint-disable-line react-hooks/exhaustive-deps
  return { ...st, more: () => fetchPage(st.items.length, true) };
}
